module.exports = __webpack_public_path__ + "1b71ad19b3b2bdb0e63db07d279e55f1.ttf";